var _g, _circle, _circle2, _circle3, _g2, _circle4, _g3, _g4, _use, _g5, _g6, _g7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTozmlogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 202 202",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(101,101)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tick"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 95,
    y1: 0,
    x2: 101,
    y2: 0,
    stroke: "black",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "piece"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L100,0 A100,100 0 0,0 86.6,-50 Z",
    fill: "#0384fc",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L100,0 A100,100 0 0,0 86.6,-50 Z",
    fill: "#fdfc26",
    stroke: "black",
    strokeWidth: 2,
    transform: "rotate(30)"
  })), /*#__PURE__*/React.createElement("use", {
    href: "#piece",
    transform: "rotate(60)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#piece",
    transform: "rotate(120)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#piece",
    transform: "rotate(180)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#piece",
    transform: "rotate(240)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#piece",
    transform: "rotate(300)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 101,
    cy: 101,
    r: 55,
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 101,
    cy: 101,
    r: 98,
    fill: "none",
    stroke: "black",
    strokeWidth: 6
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 101,
    cy: 101,
    r: 98,
    fill: "none",
    stroke: "#ccc",
    strokeWidth: 2
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(101,101)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ticks"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#tick",
    transform: "rotate(3.75)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#tick",
    transform: "rotate(7.5)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#tick",
    transform: "rotate(11.25)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#tick",
    transform: "rotate(15)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#tick",
    transform: "rotate(18.75)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#tick",
    transform: "rotate(22.5)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#tick",
    transform: "rotate(26.25)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#tick",
    transform: "rotate(30)"
  })), /*#__PURE__*/React.createElement("use", {
    href: "#ticks",
    transform: "rotate(30)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#ticks",
    transform: "rotate(60)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#ticks",
    transform: "rotate(90)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#ticks",
    transform: "rotate(120)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#ticks",
    transform: "rotate(150)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#ticks",
    transform: "rotate(180)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#ticks",
    transform: "rotate(210)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#ticks",
    transform: "rotate(240)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#ticks",
    transform: "rotate(270)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#ticks",
    transform: "rotate(300)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#ticks",
    transform: "rotate(330)"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 101,
    cy: 101,
    r: 22,
    fill: "black",
    stroke: "black",
    strokeWidth: 2
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "letT",
    fill: "#000",
    transform: "rotate(-45) translate(-10,55)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 12.744 25.2 L 7.344 25.2 L 7.344 4.86 L 0 4.86 L 0 0 L 20.304 0 L 20.304 4.86 L 12.744 4.86 L 12.744 25.2 Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "letO"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 81.4,
    cy: 27.9,
    r: 12.9,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81.4,
    cy: 27.9,
    r: 6.9,
    fill: "#fdfc26"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    href: "#letO",
    transform: "translate(38.9,145.4)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "letZ",
    fill: "#000",
    transform: "rotate(15) translate(113.8,-16.7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 20.088 25.2 L 0 25.2 L 0 21.528 L 13.788 3.132 L 15.408 5.004 L 0.936 5.004 L 0.936 0 L 19.692 0 L 19.692 3.636 L 5.976 22.068 L 4.32 20.376 L 20.088 20.376 L 20.088 25.2 Z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "letM",
    fill: "#000",
    transform: "rotate(45) translate(130.5,-88.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.292 25.2 L 0 25.2 L 0 0 L 4.932 0 L 14.112 14.94 L 10.872 14.904 L 20.16 0 L 24.876 0 L 24.876 25.2 L 19.584 25.2 L 19.584 16.56 A 111.625 111.625 0 0 1 19.622 13.573 Q 19.66 12.159 19.736 10.896 A 67.613 67.613 0 0 1 19.746 10.728 Q 19.908 8.136 20.304 5.58 L 20.952 7.272 L 13.572 18.72 L 11.196 18.72 L 3.96 7.344 L 4.572 5.58 Q 4.968 7.992 5.13 10.53 A 71.079 71.079 0 0 1 5.229 12.568 Q 5.26 13.473 5.276 14.471 A 132.024 132.024 0 0 1 5.292 16.56 L 5.292 25.2 Z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "letI",
    fill: "#000",
    transform: "rotate(15) translate(116.4,133.8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.824 25.2 L 0 25.2 L 0 20.556 L 4.212 20.556 L 4.212 4.644 L 0 4.644 L 0 0 L 13.824 0 L 13.824 4.644 L 9.612 4.644 L 9.612 20.556 L 13.824 20.556 L 13.824 25.2 Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTozmlogo);
export default __webpack_public_path__ + "static/media/tozmlogo.8a85e38c256f17faea806ba9e165f80b.svg";
export { ForwardRef as ReactComponent };